import { isNil } from 'ramda'

import type { HeroCenteredComponent } from '@twisto/api-cms'

import { Button, StrapiMedia } from 'homepage/components/atoms'
import { useUrlWithParams } from 'homepage/libs/hooks'

import { HeroDescription } from '../../hero-description'
import { HeroTitle } from '../../hero-title'

import * as styles from './centered.styles'

type CenteredProps = {
  isActive: boolean
  isInner?: boolean
  imagePriority?: boolean
}

export const Centered = ({
  title,
  highlightedTitle,
  description,
  descriptionHighlighted,
  cta,
  backgroundImage,
  hasGradient = true,
  isActive,
  isInner,
  imagePriority = false,
}: HeroCenteredComponent & CenteredProps) => {
  const ctaUrl = useUrlWithParams(cta?.link, cta?.includeUrlParams)

  return (
    <div
      css={[
        styles.slider,
        isActive ? styles.active : '',
        isInner ? styles.inner : '',
      ]}
    >
      <div css={styles.backgroundWrapper}>
        {/* eslint-disable-next-line @typescript-eslint/no-unnecessary-condition */}
        <div css={styles.background(hasGradient ?? true)}>
          {!isNil(backgroundImage?.url) && (
            <StrapiMedia priority={imagePriority} {...backgroundImage} />
          )}
        </div>
      </div>
      <div css={styles.content}>
        <div css={styles.hero}>
          <div css={styles.heroCell}>
            <div css={styles.cellContent}>
              {title && (
                <HeroTitle highlighted={highlightedTitle} title={title} />
              )}
              {description && (
                <HeroDescription
                  description={description}
                  highlighted={descriptionHighlighted}
                />
              )}
              {cta?.text && cta.link && (
                <div css={styles.cta}>
                  <Button
                    key={cta.id}
                    text={cta.text}
                    url={ctaUrl}
                    variant="inverted"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
